"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertEnToEnUS = exports.getDecimalSeparator = void 0;
const getDecimalSeparator = () => {
    let decSep = '.';
    try {
        // this works in FF, Chrome, IE, Safari and Opera
        const float = 3 / 2;
        const sep = parseFloat(float.toString()).toLocaleString().substring(1, 2);
        if (sep === '.' || sep === ',') {
            decSep = sep;
        }
    }
    catch (e) {
        console.warn('Failed to detect the decimal separator');
    }
    return decSep;
};
exports.getDecimalSeparator = getDecimalSeparator;
const convertEnToEnUS = (locale) => {
    if (locale === 'en') {
        return 'en-US';
    }
    return locale;
};
exports.convertEnToEnUS = convertEnToEnUS;
//# sourceMappingURL=localizationUtils.js.map